import { useMemo, useState } from 'react';
import { STORAGE } from '../constants';
import { LocalStorageService } from '../services/local-storage.service';

export const useSession = () => {
  const [session] = useState(LocalStorageService.get(STORAGE.SESSION));
  const [selectedAccount] = useState(LocalStorageService.get(STORAGE.SELECTED_ACCOUNT));
  const [accounts] = useState(LocalStorageService.get(STORAGE.ACCOUNTS));
  const [role] = useState<any>(LocalStorageService.get(STORAGE.ROLE_DATA));

  const profile = useMemo(() => {
    // El rol efectivo vive en session.user.roles[0]; session.profile suele venir vacío.
    const raw = session?.user?.roles?.[0] ?? session?.profile ?? '';
    return raw ? raw.toLowerCase() : '';
  }, [session?.user?.roles, session?.profile]);

  return {
    session,
    profile,
    role,
    selectedAccount,
    accounts
  };
};
